import React from "react";
import { postData } from "../../../../api/componentAPIs";
import CustomConfirmationDialog from "../../Dispatch/RouteExecution/DriverPopUp/common/CustomConfirmationDialog";
import { withSnackbar } from "notistack";

const DeleteHoliday = (props) => {
  // Deleting holiday from the table
  const deleteHoliday = () => {
    const holidayData = props.selectedHolidayData;
    if (holidayData) {
      const requestParams = {
        holidayId: holidayData.holidayId,
      };
      postData("DeleteHoliday", requestParams).then(
        (response) => {
          if (response && response.status >= 200 && response.status < 400) {
            props.enqueueSnackbar(
              `Deleted holiday ${holidayData.holidayName} `,
              {
                variant: "success",
              }
            );
            props.getAllHolidays();
          } else {
            props.enqueueSnackbar(
              `Error deleting holiday ${holidayData.holidayName} `,
              { variant: "error" }
            );
          }
          props.onCancel();
        },
        (error) => {
          props.enqueueSnackbar(
            `Error deleted holiday ${holidayData.holidayName} `,
            {
              variant: "error",
            }
          );
          props.onCancel();
        }
      );
    }
  };

  return (
    <>
      {props.selectedHolidayData && (
        <CustomConfirmationDialog
          title="Delete Holiday"
          cancelButtonLabel="Cancel"
          confirmButtonLabel="Remove"
          mode="danger"
          onConfirm={deleteHoliday}
          onCancel={props.onCancel}
        >
          {`Are you sure you want to delete selected holiday "${props.selectedHolidayData.holidayName}" from holidayList?`}
        </CustomConfirmationDialog>
      )}
    </>
  );
};

export default withSnackbar(DeleteHoliday);
